import app, { handle_login_params } from './application-container';
import { console_log } from './utility';
import parseParams from './util/parseParams';
import { frontend_service_container } from '@phi/frontend/service-container';
import { getUser } from '@phi/frontend/api/calls';

export type Message = LoginMessage;

export type PhiMessage<T extends string, P> = {
    type: T;
    payload: P;
}

export type LoginMessage = PhiMessage<'login', string>

export default function on_message(e: MessageEvent) {
    console_log('Post message received in application element.');
    console_log('e.origin = ' + e.origin);

    switch (e.origin) {
        case app.state.onshape_server:
            onshape_message(e);
            break;

        case location.origin:
            phi_message(e);
            break;

        default:
            break;
    }
}

export function onshape_message(e: MessageEvent) {
    // we no longer do anything here, but keeping it just in case
}

export function phi_message(e: MessageEvent) {
    const message = e.data as undefined | Message;
    if (!message) return;
    switch (message.type) {
        case 'login':
            console.log("P2:")
            console.log(message.payload)
            return on_login(message.payload);

        default:
            break;
    }
}

export async function on_login(search: string): Promise<void> {
    const container = frontend_service_container();
    const params = parseParams(search);

    handle_login_params(params);
    console.log("P1:")
    console.log(params)

    await getUser().then(x => {
        if (x instanceof Error)
            return;
        app.state.user = x;
        Object.assign(app.settings, x.settings);
    });

    const session_type = container.authentication.session_type.value;

    if (!container.state.user?.stripe_subscription_id)
        container.subscriptions.show_select_a_subscription_page();
    else if (session_type.has('onshape')) {
        await container.authentication.authenticate_through_onshape();
        container.state.should_load_app = true;
    }

    container.state.spinner = undefined;
}
